/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "UintUtils__InsufficientPadding",
        type: "error",
    },
    {
        inputs: [],
        name: "UintUtils__InvalidBase",
        type: "error",
    },
];
const _bytecode = "0x60808060405234601757603a9081601d823930815050f35b600080fdfe600080fdfea2646970667358221220be493d282a6a3c14120d9748477f8c7d38161804396a6727c27f8633f9cbe58864736f6c63430008140033";
const isSuperArgs = (xs) => xs.length > 1;
export class UintUtils__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
UintUtils__factory.bytecode = _bytecode;
UintUtils__factory.abi = _abi;
